import { getFallbackValueIfNull } from 'owa-options-core';
import store from '../data/store/store';
import { getCalendarOptions } from 'owa-calendar-processing-configuration';
/*
    Gets the fallback value for forward meeting notification option in calendar events and invitation settings
*/
export default function getForwardMeetingNotificationOption() {
    return getFallbackValueIfNull(store().removeForwardedMeetingNotifications, getCalendarOptions().RemoveForwardedMeetingNotifications);
}
//# sourceMappingURL=getForwardMeetingNotificationOption.js.map